/**
 * Debug utilities for development environment detection
 */

/**
 * Check if the current environment is localhost
 * @returns {boolean} True if running on localhost
 */
export function isLocalhost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;
  
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname.startsWith('localhost:') ||
    hostname.startsWith('127.0.0.1:')
  );
}

/**
 * Check if the current environment is development
 * @returns {boolean} True if in development mode
 */
export function isDevelopment(): boolean {
  return process.env.NODE_ENV === 'development';
}

/**
 * Check if debug features should be enabled
 * @returns {boolean} True if debug features should be shown
 */
export function shouldShowDebugFeatures(): boolean {
  return isLocalhost() && isDevelopment();
}